import { useEffect, useState } from 'react';

const KEY = 'pfc_cookie_consent';
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

const loadClarity = () => {
  if (!CLARITY_ID || window.clarity) return;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_ID);
};

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  useEffect(() => {
    if (choice !== 'accepted') return;
    loadClarity();
    if (typeof window.gtag === 'function') window.gtag('consent', 'update', { ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted', analytics_storage: 'granted' });
  }, [choice]);
  if (choice) return null;
  const decide = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[300] bg-slate-900 text-white p-4">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center gap-3 text-sm">
        <p className="flex-1">We'd like to use analytics and advertising cookies (Google Analytics, Google Ads) and Microsoft Clarity (anonymised session recordings) to improve this site. Nothing is stored unless you accept. <a href="/privacy" className="underline">Privacy</a></p>
        <div className="flex gap-2">
          <button data-testid="cookie-decline" onClick={() => decide('declined')} className="px-4 py-2 rounded-full border border-white/40">Decline</button>
          <button data-testid="cookie-accept" onClick={() => decide('accepted')} className="px-4 py-2 rounded-full bg-white text-slate-900 font-medium">Accept</button>
        </div>
      </div>
    </div>
  );
}
